<template>
  <div class="header">
    <!-- Logo -->
    <div class="header-left-mobile">
      <router-link to="/admin-template/admin-index" class="logo">
        <img src="@/assets/admin_img/logo-dark.png" alt="Logo" />
      </router-link>
      <router-link to="/admin-template/admin-index" class="logo logo-small">
        <img src="@/assets/admin_img/logo-small-dark.png" alt="Logo" width="30" height="30" />
      </router-link>
    </div>
    <!-- /Logo -->
    <div class="toggle-group">
      <a href="javascript:void(0);" id="toggle_btn" @click="toggleSidebar">
        <i class="bx bx-arrow-from-right"></i>
      </a>
    </div>

    <div class="top-nav-search">
      <form>
        <input type="text" class="form-control" placeholder="Search" />
        <button class="btn" type="submit"><i class="bx bx-search"></i></button>
      </form>
    </div>

    <!-- Mobile Menu Toggle -->
    <a class="mobile_btn" id="mobile_btn" @click="toggleSidebar1">
      <i class="fa fa-bars"></i>
    </a>
    <!-- /Mobile Menu Toggle -->

    <!-- Header Right Menu -->
    <ul class="nav user-menu">
      <li class="nav-item dark-group">
        <div class="dark-option">
          <a
            href="javascript:;"
            :class="{ active: isLightMode }"
            @click="toggleLightMode"
            data-bs-theme-value="light"
          >
            <i class="bx bx-brightness"></i>
          </a>
          <a
            href="javascript:;"
            :class="{ active: isDarkMode }"
            @click="toggleDarkMode"
            data-bs-theme-value="dark"
          >
            <i class="bx bx-moon"></i>
          </a>
        </div>
      </li>
      <li class="nav-item chat-user-icon">
        <a href="javascript:;">
          <i class="bx bx-message-square-detail"></i>
        </a>
      </li>
      <!-- Notifications -->
      <li class="nav-item dropdown noti-dropdown chat-user-icon">
        <a href="javascript:;" class="dropdown-toggle nav-link" data-bs-toggle="dropdown">
          <i class="bx bx-bell"></i>
        </a>
        <div class="dropdown-menu notifications">
          <div class="topnav-dropdown-header">
            <span class="notification-title">Notifications</span>
            <a href="javascript:void(0)" class="clear-noti"> Clear All </a>
          </div>
          <div class="noti-content">
            <ul class="notification-list">
              <li class="notification-message">
                <router-link to="/admin-template/notification">
                  <div class="media d-flex">
                    <span class="avatar avatar-sm flex-shrink-0">
                      <img
                        class="avatar-img rounded-circle"
                        alt="User Image"
                        src="@/assets/admin_img/profiles/avatar-2.jpg"
                      />
                    </span>
                    <div class="media-body flex-grow-1">
                      <p class="noti-details">
                        <span class="noti-title">Alexander Manuel</span> invited you to
                        attend to his event goo in gotham bar
                      </p>
                      <p class="noti-time">
                        <span class="notification-time">4 mins ago</span>
                      </p>
                    </div>
                  </div>
                </router-link>
              </li>
              <li class="notification-message">
                <router-link to="/admin-template/notification">
                  <div class="media d-flex">
                    <span class="avatar avatar-sm flex-shrink-0">
                      <img
                        class="avatar-img rounded-circle"
                        alt="User Image"
                        src="@/assets/admin_img/profiles/avatar-1.jpg"
                      />
                    </span>
                    <div class="media-body flex-grow-1">
                      <p class="noti-details">
                        <span class="noti-title">Elizabeth Sosa</span> posted a comment on
                        your status
                      </p>
                      <p class="noti-time">
                        <span class="notification-time">6 mins ago</span>
                      </p>
                    </div>
                  </div>
                </router-link>
              </li>
              <li class="notification-message">
                <router-link to="/admin-template/notification">
                  <div class="media d-flex">
                    <span class="avatar avatar-sm flex-shrink-0">
                      <img
                        class="avatar-img rounded-circle"
                        alt="User Image"
                        src="@/assets/admin_img/profiles/avatar-4.jpg"
                      />
                    </span>
                    <div class="media-body flex-grow-1">
                      <p class="noti-details">
                        <span class="noti-title">Mark Villiams</span> shared your status
                        update
                      </p>
                      <p class="noti-time">
                        <span class="notification-time">8 mins ago</span>
                      </p>
                    </div>
                  </div>
                </router-link>
              </li>
              <li class="notification-message">
                <router-link to="/admin-template/notification">
                  <div class="media d-flex">
                    <span class="avatar avatar-sm flex-shrink-0">
                      <img
                        class="avatar-img rounded-circle"
                        alt="User Image"
                        src="@/assets/admin_img/profiles/avatar-8.jpg"
                      />
                    </span>
                    <div class="media-body flex-grow-1">
                      <p class="noti-details">
                        <span class="noti-title">Horace Keene</span> posted a comment on
                        your photo
                      </p>
                      <p class="noti-time">
                        <span class="notification-time">12 mins ago</span>
                      </p>
                    </div>
                  </div>
                </router-link>
              </li>
            </ul>
          </div>
          <div class="topnav-dropdown-footer">
            <router-link to="/admin-template/notification">View all Notifications</router-link>
          </div>
        </div>
      </li>
      <!-- /Notifications -->

      <!-- User Menu -->
      <li class="nav-item dropdown has-arrow drop-user-profile">
        <a
          href="javascript:;"
          class="dropdown-toggle nav-link name-profile"
          data-bs-toggle="dropdown"
        >
          <span class="user-profile-grp">
            <span class="user-img"
              ><img
                class="rounded-circle"
                src="@/assets/admin_img/profiles/avatar-2.jpg"
                alt="Seema Sisty"
            /></span>
            <span class="user-detail">
              <span class="drop-user-name">Anderson</span>
              <span class="drop-user-role">Administrator</span>
            </span>
          </span>
        </a>
        <div class="dropdown-menu">
          <div class="user-header">
            <div class="avatar avatar-sm">
              <img
                src="@/assets/admin_img/profiles/avatar-2.jpg"
                alt="User Image"
                class="avatar-img rounded-circle"
              />
            </div>
            <div class="user-text">
              <h6>Anderson</h6>
              <p class="text-muted mb-0">Administrator</p>
            </div>
          </div>
          <router-link class="dropdown-item" to="/admin-template/profile-settings"
            >My Profile</router-link
          >
          <router-link class="dropdown-item" to="/admin-template/profile-settings"
            >Account Settings</router-link
          >
          <router-link class="dropdown-item" to="/admin-template/">Logout</router-link>
        </div>
      </li>
      <!-- /User Menu -->
    </ul>
    <!-- /Header Right Menu -->
  </div>
  <sidesettings></sidesettings>
</template>
<script>
export default {
  data() {
    return {
      isDarkMode: false,
      isLightMode: false,
    };
  },
  methods: {
    toggleDarkMode() {
      document.body.classList.add("darkmode");
      this.isDarkMode = true;
      this.isLightMode = false;
      localStorage.setItem("darkMode", "enabled");
    },
    toggleLightMode() {
      document.body.classList.remove("darkmode");
      this.isDarkMode = false;
      this.isLightMode = true;
      localStorage.setItem("darkMode", null);
    },
    isCustomDropdown() {
      //Search bar
      var searchOptions = document.getElementById("search-close-options");
      var dropdown = document.getElementById("search-dropdown");
      var searchInput = document.getElementById("search-options");

      searchInput.addEventListener("focus", () => {
        var inputLength = searchInput.value.length;
        if (inputLength > 0) {
          dropdown.classList.add("show");
          searchOptions.classList.remove("d-none");
        } else {
          dropdown.classList.remove("show");
          searchOptions.classList.add("d-none");
        }
      });

      searchInput.addEventListener("keyup", () => {
        var inputLength = searchInput.value.length;
        if (inputLength > 0) {
          dropdown.classList.add("show");
          searchOptions.classList.remove("d-none");
        } else {
          dropdown.classList.remove("show");
          searchOptions.classList.add("d-none");
        }
      });

      searchOptions.addEventListener("click", () => {
        searchInput.value = "";
        dropdown.classList.remove("show");
        searchOptions.classList.add("d-none");
      });

      document.body.addEventListener("click", (e) => {
        if (e.target.getAttribute("id") !== "search-options") {
          dropdown.classList.remove("show");
          searchOptions.classList.add("d-none");
        }
      });
    },
    initActiveMenu(ele) {
      setTimeout(() => {
        if (document.querySelector("#sidebar")) {
          let a = document
            .querySelector("#sidebar")
            .querySelector('[href="' + ele + '"]');

          if (a) {
            a.classList.add("active");
            let parentCollapseDiv = a.closest(".collapse.menu-dropdown");
            if (parentCollapseDiv) {
              parentCollapseDiv.classList.add("show");
              parentCollapseDiv.parentElement.children[0].classList.add("active");
              parentCollapseDiv.parentElement.children[0].setAttribute(
                "aria-expanded",
                "true"
              );
              if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
                parentCollapseDiv.parentElement
                  .closest(".collapse")
                  .classList.add("show");
                if (
                  parentCollapseDiv.parentElement.closest(".collapse")
                    .previousElementSibling
                )
                  parentCollapseDiv.parentElement
                    .closest(".collapse")
                    .previousElementSibling.classList.add("active");
              }
            }
          }
        }
      }, 1000);
    },
    toggleSidebar() {
      const body = document.body;
      body.classList.toggle("mini-sidebar");
    },
    toggleSidebar1() {
      const wrapper = document.querySelector(".main-wrapper");
      const sidebarOverlay = document.querySelector(".sidebar-overlay");
      wrapper.classList.toggle("slide-nav");
      document.documentElement.classList.toggle("menu-opened");
    },
    handleMouseOver(e) {
      e.stopPropagation();
      const body = document.body;
      const toggleBtn = document.getElementById("toggle_btn");
      const sidebar = e.target.closest(".sidebar");

      if (
        body.classList.contains("mini-sidebar") &&
        toggleBtn &&
        toggleBtn.style.display !== "none"
      ) {
        if (sidebar) {
          body.classList.add("expand-menu");
          this.slideDownSubmenu();
        } else {
          body.classList.remove("expand-menu");
          this.slideUpSubmenu();
        }
        return false;
      }
    },
    slideDownSubmenu() {
      const subdropUlList = document.querySelectorAll(".subdrop + ul");
      subdropUlList.forEach((ul) => {
        ul.style.display = "block";
      });
    },
    slideUpSubmenu() {
      const subdropUlList = document.querySelectorAll(".subdrop + ul");
      subdropUlList.forEach((ul) => {
        ul.style.display = "none";
      });
    },
  },
  mounted() {
    let darkMode = localStorage.getItem("darkMode");
    if (darkMode === "enabled") {
      this.toggleDarkMode();
    } else {
      this.toggleLightMode();
    }
    document.addEventListener("mouseover", this.handleMouseOver);
    document.addEventListener("mouseover", function (e) {
      e.stopPropagation();
      if (
        document.body.classList.contains("mini-sidebar") &&
        document.getElementById("toggle_btn").offsetParent !== null
      ) {
        var target = e.target.closest(".sidebar");
        if (target) {
          document.body.classList.add("expand-menu");
          var subdropUl = document.querySelectorAll(".subdrop + ul");
          subdropUl.forEach(function (ul) {
            ul.style.display = "block";
          });
        } else {
          document.body.classList.remove("expand-menu");
          var subdropUl = document.querySelectorAll(".subdrop + ul");
          subdropUl.forEach(function (ul) {
            ul.style.display = "none";
          });
        }
        e.preventDefault();
        return false;
      }
    });
  },
  beforeUnmount() {
    document.removeEventListener("mouseover", this.handleMouseOver);
  },
};
</script>
